import { useState } from 'react';
import { combineStyles } from 'helpers/helpers';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import { Trans, withTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { put } from 'helpers/apiHelpers';
import makeStyles from '@material-ui/styles/makeStyles';
import classNames from 'classnames';
import IconPowerSettingsCircleFill from 'assets/Icons/IconPowerSettingsCircleFill';

const useStyles = makeStyles({
  button: {
    lineHeight: 0,
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  buttonLoading: {
    cursor: 'not-allowed',
  },
  buttonOff: {
    color: '#F23B2F',
  },
  buttonOn: {
    color: '#09B40F',
  },
});

const SubscriptionMarkToRemove = ({ subscription, onUpdate }) => {
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();

  const toggleSubscriptionState = async () => {
    setIsLoading(true);

    try {
      await put(`/subscription/${subscription.id}`, {
        markToRemove: !subscription.markedToRemove,
      });

      onUpdate();
    } finally {
      setIsLoading(false);
    }
  };

  if (!subscription.markedToRemove) {
    return (
      <Tooltip
        placement="top"
        title={
          <Trans
            i18nKey="subscription.dialog.markToRemove.disable.tooltip"
            components={{ br: <br /> }}
          />
        }
      >
        <button
          type="button"
          disabled={isLoading}
          onClick={toggleSubscriptionState}
          className={classNames({
            [classes.button]: true,
            [classes.buttonOff]: true,
            [classes.buttonLoading]: isLoading,
          })}
        >
          <IconPowerSettingsCircleFill />
        </button>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      title={
        <Trans
          i18nKey="subscription.dialog.markToRemove.activate.tooltip"
          components={{ br: <br /> }}
        />
      }
    >
      <button
        type="button"
        disabled={isLoading}
        onClick={toggleSubscriptionState}
        className={classNames({
          [classes.button]: true,
          [classes.buttonOn]: true,
          [classes.buttonLoading]: isLoading,
        })}
      >
        <IconPowerSettingsCircleFill />
      </button>
    </Tooltip>
  );
};

const combinedStyles = combineStyles(buttonsStyle, extendedFormsStyle);

export default withTranslation()(
  withStyles(combinedStyles)(SubscriptionMarkToRemove)
);
